//@flow
import * as Immutable from 'immutable';

import {
    CreateIncrementalPjpRequest,
    RidersIds,
    EntityIds
} from 'common/models/flow/CreateIncrementalPjpRequest';
import type {
    CreateIncrementalPjpRequestModelType,
    RidersIdsModelType,
    EntityIdsModelType
} from 'common/models/flow/CreateIncrementalPjpRequest';

class InternalCreateIncrementalPjpRequest extends CreateIncrementalPjpRequest {
    static fromJS(
        json: CreateIncrementalPjpRequestModelType
    ): InternalCreateIncrementalPjpRequest {
        const state: Object = Object.assign({}, json);
        state.outletsData = InternalEntityIds.fromJS(state.outletsData);
        state.ridersData = InternalEntityIds.fromJS(state.ridersData);
        return new this(Immutable.Map(state));
    }
}

class InternalRidersIds extends RidersIds {
    static fromJS(json: RidersIdsModelType): InternalRidersIds {
        const state: Object = Object.assign({}, json);
        state.ids = Immutable.List(state.ids);
        return new this(Immutable.Map(state));
    }
}

class InternalEntityIds extends EntityIds {
    static fromJS(json: EntityIdsModelType): InternalEntityIds {
        const state: Object = Object.assign({}, json);
        state.ids = Immutable.List(state.ids);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalCreateIncrementalPjpRequest as CreateIncrementalPjpRequest,
    InternalRidersIds as RidersIds,
    InternalEntityIds as EntityIds
};
